import { createContext } from 'react';
import { PropsOf } from '@chakra-ui/react';

import { UploadedFileInfo } from 'components/Upload/types';
import TreezorUpload from 'features/Onboarding/legacy/components/TreezorUpload';

export interface OBUploadContextType {
  onSuccessfulUpload: (uploadedFile: UploadedFileInfo) => Promise<void>;
  uploadFile: PropsOf<typeof TreezorUpload>['uploadFile'];
}

const OBUploadContext = createContext<OBUploadContextType>({
  onSuccessfulUpload: () => {
    throw new Error('NOT IMPLEMENTED');
  },
  uploadFile: () => {
    throw new Error('NOT IMPLEMENTED');
  },
});

export default OBUploadContext;
